"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
export default function CoreBelief() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section className="relative w-full overflow-hidden bg-[#264256] flex items-center justify-center min-h-[40vh] md:min-h-[50vh] py-10 md:py-16">
      <div ref={ref} className={cn("relative z-10 container mx-auto px-6 flex flex-col items-center text-center max-w-5xl transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <span className="font-default text-[12px] text-accent-foreground uppercase tracking-widest mb-6 block font-semibold">
          EU Cross-Border Healthcare Directive
        </span>
        <h1 className="font-default font-bold text-4xl md:text-[60px] leading-[1.1] text-white tracking-normal mb-6 max-w-4xl">
          Your journey to recovery.
        </h1>
        <p className="font-default font-medium text-base md:text-[20px] text-white/90 leading-relaxed max-w-2xl mb-10">From your first online consultation to rehabilitation in Birstonas. One coordinated journey. No gaps.</p>
        <Button asChild className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-10 text-sm uppercase tracking-widest hover:tracking-[0.06em] transition-all duration-300 border border-ring shadow-md">
          <Link to="/#request-your-consultation">Book a Consultation</Link>
        </Button>
      </div>
    </section>;
}